export const getters = {

}



// WEBPACK FOOTER //
// ./src/store/getters.js